import { Button } from "@mui/material";
import { AuditTrailModel } from "../../../../Generated/Commodity-Management-Api";
import { StoneXGrid, StoneXLoading, StoneXRow } from "../../../StoneX";
import { StoneXModal } from "../../../StoneXMui";
import { useMemo } from "react";
import { ICellRendererParams } from "ag-grid-community";
import { EnumHelper, timestampFromDateString } from "../../../../Helpers";
import dayjs from "dayjs";

interface ViewAuditTrailModalProps {
  AuditTrailModels: AuditTrailModel[];
  open: boolean;
  isLoading: boolean;
  onClose: () => void;
}

export default function ViewAuditTrailModal(props: ViewAuditTrailModalProps) {

  const { AuditTrailModels, open, isLoading, onClose } = props;

  const rows = useMemo(() => {
    return AuditTrailModels.flatMap(event => {
      return Object.keys(event.properties).map(key => ({
        date: event.date,
        user: event.user,
        userAction: event.userAction,
        property: key,
        value: event.properties[key]
      }));
    });
  }, [AuditTrailModels]);

  const columns = useMemo(() => [
    {
      field: 'date',
      flex: 1,
      valueFormatter: (params: any) => timestampFromDateString(params.value)
    },
    {
      field: 'user',
      flex: 1
    },
    {
      field: 'userAction',
      flex: 1
    },
    {
      field: 'property',
      flex: 1,
      cellRenderer: (params: ICellRendererParams) => EnumHelper.enumToString(params.data.property)
    },
    {
      headerName: 'New Value',
      field: 'value',
      flex: 1,
      cellDataType: 'text'
    }
  ], []);

   return <StoneXModal header={"Audit Trail"} open={open} width={"80%"} onClose={onClose}>

      <StoneXLoading show={isLoading} />

      {!isLoading && rows.length > 0 && <StoneXGrid rows={rows} columns={columns} hideGridOptions />}

      {!isLoading && rows.length === 0 && <>There is no audit trail history.</>}

      <StoneXRow justify="end" marginDirection='top'>
        <Button variant="outlined" onClick={onClose}>Close</Button>
      </StoneXRow>

    </StoneXModal>
}